import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CheckdialogData } from '../../_model/shared';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'check-dialog',
    templateUrl: './checkdialog.component.html',
    styleUrls: ['checkdialog.component.scss'],
    imports: [TranslateModule]
})
export class CheckdialogComponent implements OnInit{

  public data: CheckdialogData
  public dialogRef: NgbModalRef;

  constructor(
  ){}

  onClick(result: string): void {
    
    this.dialogRef.close(result);
  }

  ngOnInit() {
  }







}
